import { Component, Host, h, Prop, Watch, Element, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'ui-cms-grid-element',
  styleUrl: 'ui-cms-grid-element.scss',
  shadow: true,
})
export class UiCmsGridElement {
  @Element() el: HTMLElement;

  @Prop({
    reflect: true,
  })
  columns = 12;

  @Prop({
    reflect: true,
  })
  hideSeparator = false;

  @Prop({
    reflect: true,
  })
  centered = false;

  @Prop({
    reflect: true,
  })
  offset = 0;

  @Event() gridReady: EventEmitter;

  @Watch('columns')
  @Watch('centered')
  onColumnsChange(newValue: number) {
    this.el.style.setProperty('--grid-element-span', newValue.toString());
    if (this.centered && this.columns === 8) {
      this.el.style.setProperty('--start-column', ((12 - this.columns) / 2 + 1).toString());
    }

    this.gridReady.emit();
  }

  componentDidLoad() {
    this.onColumnsChange(this.columns);
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
